<template>
    <div class="min-h-[100vh] w-full">
        <div
            v-if="!betradarUrl"
            class="relative grid h-full gap-4 px-5 lg:px-12"
        >
            <div v-if="isLoading" class="absolute -ml-12 h-full w-screen">
                <ThaCommonLoaderSport />
            </div>
        </div>
        <div v-else class="loader-image flex h-full min-h-screen">
            <iframe
                id="iframe"
                ref="iframe"
                :src="betradarUrl"
                class="flex w-full"
            ></iframe>
        </div>
    </div>
</template>

<script setup>
import { useGamesStore } from '~/stores'
const { isMobile } = useDevice()
const betradarUrl = ref('')

const isLoading = ref(false)
const gameStoreInstance = useGamesStore()
const { getGameUrlNoAuth } = gameStoreInstance
const loadBetradar = async () => {
    try {
        isLoading.value = true
        const toSend = {
            partnerProvider: 'betradar',
            partnerGameId: 'vfb',
        }
        const { data } = await getGameUrlNoAuth(toSend)
        const url = data?.value?.data.url
        if (data?.value.status === 'OK' && isMobile) {
            setTimeout(() => {
                window.open(url, '_blank')
            })
            const router = useRouter()
            router.push('/')
        } else if (data?.value.status === 'OK') {
            betradarUrl.value = url
        } else {
            console.log('Oops')
            const router = useRouter()
            router.push('/')
        }
    } catch (error) {
        console.log(error)
    } finally {
        isLoading.value = false
    }
}
onBeforeUnmount(() => {
    if (betradarUrl.value) {
        betradarUrl.value = ''
    }
})
onMounted(async () => {
    await nextTick(async () => {
        await loadBetradar()
    })
})
</script>
